export const AUTH_CONFIG = {
  baseUrl: "/api",
  appPrefix: "admin",
};
